<template>
  <div
    class="d-flex text-center flex-column flex-md-row flex-grow-1 height-100vh"
  >
    <v-sheet
      class="layout-side mx-auto mx-md-1 d-md-flex flex-md-column justify-space-between px-2"
    >
      <div class="mt-5 mt-md-10 pt-5">
        <div class="font-weight-bold primary--text text-uppercase">
          <v-avatar size="50px">
            <span class="botter-logo-icon botter-login-logo-img" />
            <span class="botter-brand-name primary-text">BOTTER</span>
          </v-avatar>
        </div>
        <div class="title mt-3">Let's build some bots :)</div>
        <!--        <v-btn to="/" class="my-4">Take me back</v-btn>-->
      </div>
      <img class="w-full" src="../assets/img/signin-illustration.svg" />
    </v-sheet>

    <div
      class="pa-2 pa-md-4 flex-grow-1 align-center justify-center d-flex flex-column auth-content"
    >
      <div class="layout-content ma-auto w-full">
        <slot></slot>
      </div>
    </div>
    <v-snackbar
      v-model="$store.state.core.snackbar.status"
      :color="$store.state.core.snackbar.color"
      :timeout="$store.state.core.snackbar.timeout"
      :multi-line="$store.state.core.snackbar.multiLine"
      :auto-height="true"
      right
    >
      <div v-html="$store.state.core.snackbar.text" />
      <v-btn dark flat @click="$store.state.core.snackbar.status = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  computed: {},
};
</script>

<style scoped>
.layout-side {
  max-width: 420px;
  flex-direction: column;
  flex-grow: 1 !important;
  display: flex;
}

.layout-content {
  max-width: 480px;
  margin: auto;
}

.auth-content {
  overflow-y: scroll;
}

.auth-content::-webkit-scrollbar {
  display: none;
}
</style>
